import type React from "react";
import { cn } from "src/shadcn/lib/utils";
import {
  Card as ShadcnCard,
  CardHeader as ShadcnCardHeader,
  CardFooter as ShadcnCardFooter,
  CardTitle as ShadcnCardTitle,
  CardAction as ShadcnCardAction,
  CardDescription as ShadcnCardDescription,
  CardContent as ShadcnCardContent,
} from "src/shadcn/components/card";

const Card = (props: React.ComponentProps<typeof ShadcnCard>) => (
  <ShadcnCard {...props} />
);

const CardHeader = (props: React.ComponentProps<typeof ShadcnCardHeader>) => (
  <ShadcnCardHeader {...props} />
);

const CardFooter = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnCardFooter>) => (
  <ShadcnCardFooter className={cn("border-border", className)} {...props} />
);

const CardTitle = (props: React.ComponentProps<typeof ShadcnCardTitle>) => (
  <ShadcnCardTitle {...props} />
);

const CardAction = (props: React.ComponentProps<typeof ShadcnCardAction>) => (
  <ShadcnCardAction {...props} />
);

const CardDescription = (
  props: React.ComponentProps<typeof ShadcnCardDescription>
) => <ShadcnCardDescription {...props} />;

const CardContent = (props: React.ComponentProps<typeof ShadcnCardContent>) => (
  <ShadcnCardContent {...props} />
);

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};
